import styled, { css } from "styled-components";
import DisappearingTile from "components/ui/DisappearingTile";
import Detail from "components/ui/Detail";
import Button, { ButtonLevel } from "components/ui/Button";
import { colors, mediaMax, mediaMin } from "utils/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;

  ${mediaMax("lg")} {
    padding: 16px;
  }
`;

export const SectionGroup = styled.div`
  display: grid;
  gap: 16px;

  ${mediaMin("md")} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
  }

  ${mediaMin("xl")} {
    gap: 48px;
  }
`;

export const SectionTile = styled(DisappearingTile).attrs(() => ({
  size: "xl",
}))`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`;

export const HeaderSection = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const HeaderFilter = styled(Button)<{ $isActive?: boolean }>`
  ${(props) =>
    !props.$isActive &&
    css`
      background: white;
      color: ${colors.midnight};
      border: 1px solid ${colors.flax};
    `}
`;

export const Info = styled.div`
  display: flex;
  gap: 48px;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${mediaMin("md")} {
    flex-basis: 100%;
  }
`;

export const InfoItem = styled(Detail).attrs(() => ({ size: "xl" }))``;

export const InfoItemLinks = styled.div`
  display: flex;
  margin-left: 4px;
  gap: 20px;
  align-items: center;
`;

export const ValueWithStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ButtonWrapper = styled.div`
  margin: 24px 0;

  &:last-child {
    margin-bottom: 0;
  }

  & + & {
    margin-top: 0;
  }

  button {
    width: 100%;
  }
`;

export const TableButtonWrapper = styled.div`
  padding: 24px 0;
  display: flex;
  justify-content: center;

  background: ${colors.ice};
  border-radius: 0 0 8px 8px;

  button {
    max-width: 360px;
  }
`;

export const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 4px;
`;

export const TileActions = styled.div`
  display: grid;
  gap: 48px;
  padding-top: 24px;

  hr {
    width: 100%;
    height: 1px;
    margin: 0;
  }

  ${mediaMin("md")} {
    grid-template-columns: repeat(2, 1fr);

    hr {
      grid-column: 1 / span 2;
    }
  }
`;

export const DangerGhostButton = styled(Button).attrs(() => ({
  level: ButtonLevel.ghost,
}))`
  border-color: ${colors.cerise};
`;
